import { map } from 'lodash'
import { error } from '@/utils/alert'
import bus from '@/utils/eventBus'

export default {
  doConfirmedAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/rollback')
      .then(({data}) => {
        bus.$emit('is-rollback', {show: true})
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro ao definido como agendado.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/rollback/resources/methods.js